<template>
  <div>
    
    <vue-skeleton-loader :width="150" :height="25" animation="fade" class="mt-2 mx-auto bg-mint-dark rounded-l" />

    <div class="content">
      <div v-for="n in count" :key="n" class="d-flex">
        <div class="align-self-top me-3">
          <!-- <span class="icon gradient-blue color-white icon-m rounded-xs">{{ indexBukuTamu + 1 }}</span> -->
          <vue-skeleton-loader :width="45" :height="45" animation="fade" class="rounded-xs" />
        </div>
        <div class="card card-style w-100 mx-0">
          <div class="content">
            <div class="d-flex">
              <div class="align-self-top me-3">
                <!-- <span class="icon icon-xxl bg-yellow-dark color-white rounded-m"><i class="bi bi-calendar3 font-28"></i></span> -->
                <vue-skeleton-loader :width="90" :height="90" animation="fade" class="rounded-m" />
              </div>
              <div>
                <vue-skeleton-loader :width="200" :height="16" animation="fade" />
                <vue-skeleton-loader :width="150" :height="16" animation="fade" class="mt-1" />
                <vue-skeleton-loader :width="450" :height="16" animation="fade" class="mt-1" />
                <vue-skeleton-loader :width="250" :height="16" animation="fade" class="mt-1" />
                <vue-skeleton-loader :width="300" :height="16" animation="fade" class="mt-1" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    count: {
      default: 1,
      type: Number,
    },
  },
};
</script>
